(function () {
  const GLASSON_SCRIPT_SRC = 'https://media.glasses4u.io/build/try-on-ui-v5.esm.js';
  let glassonReady = false;
  let userId = null;

  function ensureScript() {
    if (!document.querySelector('script[data-glasson-try-on-ui]')) {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = GLASSON_SCRIPT_SRC;
      script.setAttribute('data-glasson-try-on-ui', 'true');
      document.body.appendChild(script);
    }
  }

  function ensureComponent() {
    if (!userId) return null;

    ensureScript();

    let glassonTryOn = document.querySelector('glasson-try-on');

    if (!glassonTryOn) {
      glassonTryOn = document.createElement('glasson-try-on');
      document.body.appendChild(glassonTryOn);
    }

    if (!glassonReady) {
      glassonTryOn.setAttribute('user-id', userId);
      glassonTryOn.setAttribute('screen', 'measurement');
      glassonTryOn.setAttribute('has-measure', 'true');

      glassonTryOn.addEventListener('ok', function (event) {
        window.dispatchEvent(new CustomEvent('glasson:pd-result', { detail: event.detail }));
      });

      glassonTryOn.addEventListener('close', function () {
        glassonTryOn.removeAttribute('open');
      });

      glassonReady = true;
    }

    return glassonTryOn;
  }

  window.GlassonPd = {
    init: function (id) {
      userId = id;
    },
    open: function () {
      const glassonTryOn = ensureComponent();
      if (!glassonTryOn) return false;

      glassonTryOn.setAttribute('screen', 'measurement');
      glassonTryOn.setAttribute('open', 'true');
      return true;
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    const config = document.getElementById('glasson-pd-config');
    if (config && config.dataset.userId) {
      window.GlassonPd.init(config.dataset.userId);
    }

    if (config && config.dataset.autoOpen === 'true') {
      window.GlassonPd.open();
    }

    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('.glasson-pd-measure-trigger');
      if (!trigger) return;

      event.preventDefault();
      window.GlassonPd.open();
    });
  });
})();
